import { render, staticRenderFns } from "./SosPopup.vue?vue&type=template&id=d707a066"
import script from "./SosPopup.vue?vue&type=script&lang=js"
export * from "./SosPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports